import trainer from '@/api/trainer';

import { FETCH_TRAINER, PATCH_TRAINER, WECHAT_UNBIND } from './types';

export default {
    [FETCH_TRAINER]({ commit }) {
        return trainer
            .get()
            .then(resp => commit(FETCH_TRAINER, resp));
    },
    [PATCH_TRAINER]({ commit }, payload) {
        return trainer
            .patch(payload)
            .then(resp => commit(FETCH_TRAINER, resp));
    },
    [WECHAT_UNBIND]({ commit }) {
        return trainer
            .wechat_unbind()
            .then(resp => commit(FETCH_TRAINER, resp));
    },
};



// WEBPACK FOOTER //
// ./src/store/trainer/actions.js